import { LayoutService } from 'src/app/layout/layout.service';
import { Component, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { Column, Dashboard } from '../dashboard';
import { DashboardService } from '../dashboard.service';
import { Title } from '@angular/platform-browser';
import * as g from 'src/app/globals';

@Component({
  selector: 'app-dashboard-index',
  templateUrl: './dashboard-index.component.html',
  styleUrls: ['./dashboard-index.component.less'],
})
export class DashboardIndexComponent implements OnInit, OnDestroy {
  @Input() dashboardId: number;

  mode = 'View';
  dashboardTitle = '';
  dashboardStructure: Dashboard;
  dashboardParams: string[];
  dashboardParamNames: string[];

  constructor(
    private dashboardService: DashboardService,
    private layoutService: LayoutService,
    private title: Title
  ) {}

  ngOnDestroy(): void {
    this.layoutService.containerTransparentBGEmitter.emit(false);
    this.title.setTitle(g.getTitleSuffix());
  }

  ngOnInit(): void {
    this.layoutService.containerTransparentBGEmitter.emit(true);
    if (this.dashboardId !== 0 && this.dashboardId !== undefined) {
      this.dashboardParams = [];
      this.dashboardParamNames = [];
      this.dashboardService
        .getDashboard(this.dashboardId)
        .subscribe((d: Dashboard) => {
          this.dashboardStructure = d;
          console.log('this.dashboardStructure', this.dashboardStructure);
          this.title.setTitle(
            this.dashboardStructure.Title + ' - ' + g.getTitleSuffix()
          );
          this.dashboardStructure.Containers.forEach((element) => {
            element.Columns.forEach((column) => {
              if (column.ColumnType === 'Parameters') {
                column.Parameters.forEach((parameter) => {
                  this.dashboardParams[parameter.Name] = '';
                  this.dashboardParamNames.push(parameter.Name);
                });
              }
            });
          });
        });
    }
  }

  getColumnWidth(column: Column): number {
    const match = column.CssClass.match(/col-lg-(\d+)/);

    if (match) {
      const number = match[1];
      return parseInt(number) * 2;
    } else {
      const match = column.CssClass.match(/col-md-(\d+)/);
      if (match) {
        const number = match[1];
        return parseInt(number) * 2;
      } else {
        return 3;
      }
    }
  }


  chartData = [
    { name: 'Aug', value: 197 },
    { name: 'Sep', value: 173 },
    { name: 'Oct', value: 259 },
    { name: 'Nov', value: 359 },
    { name: 'Dec', value: 104 },
    { name: 'Jan', value: 251 },
    { name: 'Feb', value: 85 }
  ];

  colorScheme = {
    domain: ['#3F70C9'] 
  };
}
